<template>
  <div class="content">
    <header-top></header-top>
    <div class="box">
      <div class="title">hi，您好，欢迎来到粮油销售中心</div>
      <div class="login">
<!--        <div class="account" :class="{active:this.$route.fullPath === '/login/account'}">-->
<!--          <router-link to="/login/account">扫码登录</router-link>-->
<!--        </div>-->
<!--        <div class="line"></div>-->
        <div class="mobile" :class="{active:this.$route.fullPath === '/login/mobile'}">
          <router-link to="/login/mobile">手机验证码登录</router-link>
        </div>
      </div>
      <router-view />
    </div>
    <foot></foot>
  </div>
</template>

<script>
import headerTop from "@/components/header.vue";
import foot from "@/components/footer.vue";

export default {
  components: {
    headerTop,
    foot
  },
  data() {
    return {};
  },
  methods: {
    handlerLogin() {
      this.$router.push({
        path: "/login/mobile"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  box-sizing: border-box;
  width: 490px;
  margin: 50px auto 0;
  color: #2e2c2d;
  .title {
    font-size: 24px;
    text-align-last: justify;
    margin-bottom: 60px;
  }
  .login {
    display: flex;
    justify-content: space-between;
    font-size: 25px;
    margin-bottom: 80px;
    .line {
      border-left: 1px solid #2e2c2d;
      height: 50px;
    }
    .account {
      padding: 8px 0 0 5px;
      width: 170px;
      text-align-last: justify;
      &.active {
        a {
          color: #41a5ef;
        }
        border-bottom: 2px solid #41a5ef;
      }
    }
    .mobile {
      padding: 8px 5px 0 0;
      width: 200px;
      text-align-last: justify;
      &.active {
        a {
          color: #41a5ef;
        }
        border-bottom: 2px solid #41a5ef;
      }
    }
  }
}
a {
  text-decoration: none;
  color: #2e2c2d;
}

@media screen and (min-width: 320px) and (max-width: 980px) {
  .box {
    width: 100%;
    padding: 0 10px;
    margin-top: 20px;
    .title {
      text-align-last: center;
      font-size: 18px;
    }
    .login {
      display: none;
    }
  }
}
</style>


